/**
 * nextPageOffset — shared getNextPageParam for offset-paginated infinite queries.
 *
 * The next pageParam is the cumulative item count across the pages loaded so
 * far, sent to the server as an extra `skip`. This is the single home for that
 * rule: `.getInfinite()` on the list and custom builders and the infinite
 * branch of `usePrefetch` must all page identically, or a prefetch replaces a
 * mounted query's options with a differently-paged behavior.
 */

interface OffsetPage {
  data?: unknown;
  extra?: { hasNextPage?: boolean };
}

export function nextPageOffset(
  lastPage: unknown,
  allPages: ReadonlyArray<unknown>,
): number | undefined {
  // Structural narrowing of unknown — every read below is optional-chained.
  const last = lastPage as OffsetPage | null | undefined;
  if (!last?.extra?.hasNextPage) return undefined;
  return allPages.reduce<number>((acc, page) => {
    const rows = (page as OffsetPage | null | undefined)?.data;
    return acc + (Array.isArray(rows) ? rows.length : 0);
  }, 0);
}
